import React, { Component } from 'react'
import ReactHighcharts from 'react-highcharts/ReactHighstock'

export default class LinearChartive extends Component {
  constructor (props) {
    super(props)
    this.state = { data: props.data.slice(0), update: false }
    this.config = {
      chart: {
        height: props.height
      },
      time: {
        useUTC: false,
        timezone: 'America/Bogota'
      },
      exporting: {
        filename: props.title,
        enabled: true,
        showTable: false,
        buttons: {
          contextButton: {
            menuItems: ['downloadPNG', 'downloadSVG', 'downloadCSV', 'downloadXLS']
          }
        }
      },
      scrollbar: { enabled: false },
      xAxis: {
        // events: { setExtremes: () => this.update(false) },
        tickInterval: 2 * 3600 * 1000,
        labels: {
          autoRotation: [0, -90],
          padding: 1,
          distance: 1
        },
        gridLineWidth: 1,
        ordinal: false,
        type: 'datetime',
        dateTimeLabelFormats: {
          hour: '%d-%H:%M'
        }
      },
      yAxis: {
        title: {
          text: props.ylabel
        },
        plotLines: [{
          value: props.max,
          color: '#f5222d',
          dashStyle: 'Solid',
          width: 1,
          label: {
            text: `${props.max} ${props.unit || ''}`
          }
        }, {
          value: this.props.min,
          color: '#a0d911',
          dashStyle: 'Solid',
          width: 1,
          label: {
            text: `${props.min} ${props.unit || ''}`
          }
        }],
      },
      navigator: {
        margin: 10
      },
      credits: {
        text: 'Innova',
        href: 'http://www.innovatecnologia.com/'
      },
      title: { text: props.title, y: 18 },
      rangeSelector: {
        y: -5,
        buttonTheme: { width: 50 },
        buttons: [{
          type: 'hour',
          count: 1,
          text: '1h-Live',
          events: {
            click: () => this.update(true)
          }
        }, {
          type: 'hour',
          count: 12,
          text: '12h',
          events: {
            click: () => this.update(false)
          }
        }, {
          type: 'day',
          count: 1,
          text: '1d',
          events: {
            click: () => this.update(false)
          }
        }, {
          type: 'week',
          count: 1,
          text: '1w',
          events: {
            click: () => this.update(false)
          }
        }, {
          type: 'all',
          text: 'All',
          events: {
            click: () => this.update(false)
          }
        }],
        verticalAlign: 'bottom',
        selected: 2,
        inputEnabled: false
      },
      series: [{
        type: props.type,
        color: props.color,
        allowPointSelect: true,
        data: this.state.data,
        marker: {
          enabled: true,
          radius: 2
        },
        tooltip: {
          header: false,
          pointFormat: `{point.x:%e %b %H:%M:%S} <b> {point.y:.2f} ${props.unit}</b>`
        }
      }]
    }
  }

  update (bool) {
    this.setState({ update: bool })
  }

  componentDidMount () {
    this.chart = this.refs.chart.getChart()
  }

  componentWillReceiveProps (props) {
    if (!this.state.update) return
    if (!this.props.lastValue[0]) return
    let serie = this.chart.series[0]
    let data = serie.data
    if (!data.length) return
    if (data[data.length - 1].x === props.lastValue[0]) return
    this.chart.series[0].addPoint(props.lastValue, true, true)
  }

  shouldComponentUpdate (props) { return false }

  render () {
    return (
      <div ref='container'>
        <ReactHighcharts config={this.config} ref='chart' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/charts/LinearChartLive.js